import React from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Layout } from '../templates';
// eslint-disable-next-line import/namespace
import { TicketView } from '../organisms/TicketView';
import { useSettings } from '../../stateManagement/SettingsContext';
import { appInsights } from '../../appInsights';
// import { trackEvent } from '../../Analytics/ga';

export const TicketPage: React.FC = () => {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const location = useLocation();
  const ticketData = location.state?.ticketData;
  const handleBackClick = () => {
    navigate('/playerhub');
  };
  const backClickHref = '/playerhub';
  const onClickContactUs = () => {
    appInsights.trackEvent({
      name: 'contact_us_button_clicked',
      properties: {
        source: 'TicketViewPage',
        buttonName: 'contactUsButton',
        userName: 'anonymous',
      },
    });

    navigate('/contactUs');
  };
  return (
    <Layout
      pageBgColor={settings?.configs.secondaryBgColor}
      onContactUsClick={onClickContactUs}
      settings={settings}
    >
      <Helmet>
        <title>Ticket</title>
      </Helmet>
      <Box
        display="flex"
        flexDirection="column"
        minHeight="76vh"
        backgroundColor={settings?.configs.secondaryBgColor}
      >
        <Box flex={1}>
          <TicketView
            ticketData={ticketData}
            settings={settings}
            handleBackClick={handleBackClick}
            backClickHref={backClickHref}
          />
        </Box>
      </Box>
    </Layout>
  );
};
